import { usePipelinesTableContext } from 'app/pipelines/PipelinesTable/PipelinesTableContext';

export default function useClusterMultiSelectProps() {
  const { setSelectedClusters } = usePipelinesTableContext();

  return {
    setSelectedClusters,
    renderValue: selected => `Clusters (${selected.length})`,
  };
}
